/*
 * Built with Common Launchpad 2.0.3
 */

import axios from 'axios';
import * as CONST from '../utils/constants';

export default {
	postData(cb, { data, resource }) {
		axios.post(`${CONST.EnvironmentUrl}${resource}`, data)
        .then(response => response.data)
			.then(response => {
				cb(response);
			})
			.catch(err => {
				const response = err.response || {};
				const responseData = response.data || {};
				cb({
					IsError: true,
					WebServiceSubmitStatus: false,
					HttpStatus: response.status || null,
					HttpStatusText: response.statusText || null,
					ErrorCode: err.code || null,
					WebServiceResponseMessage: responseData.ExceptionMessage || responseData.Message || err.message || response.statusText || 'Unable to submit the qualifier tool request.'
				});
			});
	},
	getUserIp(cb, { data, resource }) {
		axios.get('https://api.hostip.info/get_json.php', {
			headers: {
				'Content-Type': 'application/json'
			}
		})
        .then(response => response.data)
			.then(response => {
				cb(response);
			})
			.catch(err => cb(err.response));
	}
};
